/* tslint:disable */
/* eslint-disable */
/**
 * Admin Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OrcidPutCodeDTO,
    OrcidPutCodeDTOFromJSON,
    OrcidPutCodeDTOFromJSONTyped,
    OrcidPutCodeDTOToJSON,
    OrcidScopeDTO,
    OrcidScopeDTOFromJSON,
    OrcidScopeDTOFromJSONTyped,
    OrcidScopeDTOToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrcidAuthorizeDTO
 */
export interface OrcidAuthorizeDTO {
    /**
     * 
     * @type {number}
     * @memberof OrcidAuthorizeDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OrcidAuthorizeDTO
     */
    orcidID?: string;
    /**
     * 
     * @type {string}
     * @memberof OrcidAuthorizeDTO
     */
    orcidClientId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrcidAuthorizeDTO
     */
    accessToken?: string;
    /**
     * 
     * @type {string}
     * @memberof OrcidAuthorizeDTO
     */
    refreshToken?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrcidAuthorizeDTO
     */
    publicUsageOfLimitedOrcidData?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrcidAuthorizeDTO
     */
    tokenRevoked?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof OrcidAuthorizeDTO
     */
    lastUpdateFromOrcid?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrcidAuthorizeDTO
     */
    authorizationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrcidAuthorizeDTO
     */
    revocationDate?: Date;
    /**
     * 
     * @type {Array<OrcidPutCodeDTO>}
     * @memberof OrcidAuthorizeDTO
     */
    employmentPutCodes?: Array<OrcidPutCodeDTO>;
    /**
     * 
     * @type {Array<OrcidScopeDTO>}
     * @memberof OrcidAuthorizeDTO
     */
    orcidScopes?: Array<OrcidScopeDTO>;
}

export function OrcidAuthorizeDTOFromJSON(json: any): OrcidAuthorizeDTO {
    return OrcidAuthorizeDTOFromJSONTyped(json, false);
}

export function OrcidAuthorizeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrcidAuthorizeDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'orcidID': !exists(json, 'orcidID') ? undefined : json['orcidID'],
        'orcidClientId': !exists(json, 'orcidClientId') ? undefined : json['orcidClientId'],
        'accessToken': !exists(json, 'accessToken') ? undefined : json['accessToken'],
        'refreshToken': !exists(json, 'refreshToken') ? undefined : json['refreshToken'],
        'publicUsageOfLimitedOrcidData': !exists(json, 'publicUsageOfLimitedOrcidData') ? undefined : json['publicUsageOfLimitedOrcidData'],
        'tokenRevoked': !exists(json, 'tokenRevoked') ? undefined : json['tokenRevoked'],
        'lastUpdateFromOrcid': !exists(json, 'lastUpdateFromOrcid') ? undefined : (new Date(json['lastUpdateFromOrcid'])),
        'authorizationDate': !exists(json, 'authorizationDate') ? undefined : (new Date(json['authorizationDate'])),
        'revocationDate': !exists(json, 'revocationDate') ? undefined : (new Date(json['revocationDate'])),
        'employmentPutCodes': !exists(json, 'employmentPutCodes') ? undefined : ((json['employmentPutCodes'] as Array<any>).map(OrcidPutCodeDTOFromJSON)),
        'orcidScopes': !exists(json, 'orcidScopes') ? undefined : ((json['orcidScopes'] as Array<any>).map(OrcidScopeDTOFromJSON)),
    };
}

export function OrcidAuthorizeDTOToJSON(value?: OrcidAuthorizeDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'orcidID': value.orcidID,
        'orcidClientId': value.orcidClientId,
        'accessToken': value.accessToken,
        'refreshToken': value.refreshToken,
        'publicUsageOfLimitedOrcidData': value.publicUsageOfLimitedOrcidData,
        'tokenRevoked': value.tokenRevoked,
        'lastUpdateFromOrcid': value.lastUpdateFromOrcid === undefined ? undefined : (value.lastUpdateFromOrcid.toISOString()),
        'authorizationDate': value.authorizationDate === undefined ? undefined : (value.authorizationDate.toISOString()),
        'revocationDate': value.revocationDate === undefined ? undefined : (value.revocationDate.toISOString()),
        'employmentPutCodes': value.employmentPutCodes === undefined ? undefined : ((value.employmentPutCodes as Array<any>).map(OrcidPutCodeDTOToJSON)),
        'orcidScopes': value.orcidScopes === undefined ? undefined : ((value.orcidScopes as Array<any>).map(OrcidScopeDTOToJSON)),
    };
}


